<input type="text" #datepicker [(ngModel)]="date" class="form-control">